import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import environment from '@environments/environment';

export const OktaAuthGuard: CanMatchFn = async (
  route: Route,
  _: UrlSegment[],
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Backend rejected this user (erm-auth-403) earlier in the session. Block
  // entry into every guarded route \u2014 including via back/forward navigation
  // or a deep link \u2014 for as long as that rejection stands, since Okta's own
  // auth state has no idea the backend refused the user.
  const rejection = authService.rejection();
  if (rejection) {
    router.navigate(['/erm-auth-403'], { state: rejection });
    return false;
  }

  try {
    // Check if the user is authenticated
    const authenticated: boolean = await authService.checkAuthentication();

    if (authenticated) {
      return true;
    }

    // If the user is coming from a successful login, don't redirect to logout
    const isLoginCallback = route.path === 'auth/login/callback';
    if (isLoginCallback) {
      return true;
    }

    // If not authenticated, redirect to logout
    // Clinsphere handles auth, we do not need to navigate to logout and explicitly destroy the session

    console.log('User not authenticated. Redirecting to login');
    window.location.href = '/auth/login';
    return false;
  } catch (error) {
    console.error('Error during authentication check:', error);

    // Redirect to logout in case of errors
    try {
      console.log('Redirecting to clinsphere due to authentication error');
      // Clinsphere handles auth, we do not need to navigate to logout and explicitly destroy the session
      window.location.href = environment.clinsphereUrl;
      return false;
    } catch (error) {
      console.error('Error during logout redirect:', error);
      return false;
    }
  }
};
